export { default as default } from '../modules/unicode.js'


//////////////////
// WEBPACK FOOTER
// ../country-flag-icons/unicode/index.js
// module id = 364
// module chunks = 0 1